// A real reader touches, clicks, types or moves the mouse. The crawlers flooding the site
// pose as iPhones and run the page like a browser, but never do any of that — so anything
// that costs a server call and is not the content itself waits for this signal.
// Scroll is deliberately not counted: scripts scroll pages to trigger lazy loading.
const EVENTS = ['touchstart', 'pointerdown', 'keydown', 'wheel', 'mousemove'];
let human = false;
const waiting = new Set();

function mark() {
  if (human) return;
  human = true;
  EVENTS.forEach(e => window.removeEventListener(e, mark));
  waiting.forEach(fn => { try { fn(); } catch (_) { /* one listener must not stop the rest */ } });
  waiting.clear();
}

if (typeof window !== 'undefined') {
  EVENTS.forEach(e => window.addEventListener(e, mark, { passive: true }));
}

export const isHuman = () => human;

export function afterHuman(fn) {
  if (human) { fn(); return () => {}; }
  waiting.add(fn);
  return () => waiting.delete(fn);
}